var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _ellipse, _path43, _ellipse2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 227,
    viewBox: "0 0 187 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6238 135.164C74.4025 132.241 59.9282 114.385 65.7759 89.9384C65.7759 89.9384 73.7408 83.1708 97.6904 88.8996C121.64 94.6284 125.68 104.268 125.68 104.268C119.833 128.714 98.845 138.087 86.6238 135.164Z",
    fill: "url(#paint0_linear_325_195743)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7821 89.2048C62.7568 89.2238 62.737 89.2391 62.7225 89.2506C56.9137 113.62 71.3495 131.385 83.49 134.289C95.6304 137.193 116.543 127.884 122.39 103.523C122.382 103.506 122.372 103.484 122.358 103.455C122.323 103.386 122.27 103.282 122.192 103.146C122.037 102.876 121.789 102.482 121.416 101.989C120.669 101.005 119.423 99.6281 117.429 98.0715C113.442 94.9583 106.461 91.1227 94.5 88.2615C82.5386 85.4003 74.5779 85.6619 69.6133 86.6337C67.131 87.1197 65.397 87.7833 64.2857 88.3236C63.73 88.5937 63.3299 88.8331 63.0696 89.0041C62.9394 89.0897 62.8443 89.1581 62.7821 89.2048Z",
    fill: "url(#paint1_linear_325_195743)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.257 104.062C119.415 107.684 115.154 109.194 110.953 110.239C109.977 110.482 109.002 110.7 108.049 110.913C107.932 110.939 107.814 110.966 107.697 110.992C106.632 111.231 105.596 111.467 104.614 111.729C102.647 112.254 100.906 112.881 99.5822 113.836C93.7245 118.062 91.3655 123.31 90.4694 127.502C90.0211 129.599 89.9389 131.432 89.9687 132.74C89.9836 133.394 90.0265 133.916 90.0656 134.274C90.0851 134.454 90.1037 134.592 90.1173 134.685C90.1189 134.696 90.1205 134.706 90.1219 134.716C102.03 133.714 117.237 124.025 122.257 104.062Z",
    fill: "url(#paint2_linear_325_195743)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5962 89.7911C63.4918 94.3064 66.6084 97.5815 69.8821 100.415C70.6425 101.073 71.4127 101.708 72.1663 102.33C72.2593 102.406 72.3521 102.483 72.4446 102.559C73.2866 103.254 74.1035 103.933 74.8609 104.612C76.3771 105.97 77.6454 107.317 78.3939 108.768C81.7054 115.187 81.4341 120.935 80.3363 125.078C79.7872 127.151 79.0313 128.822 78.4128 129.975C78.1036 130.552 77.829 130.998 77.6319 131.3C77.5334 131.451 77.4543 131.566 77.4001 131.643C77.3937 131.652 77.3877 131.66 77.382 131.668C67.2167 125.386 58.0391 109.865 62.5962 89.7911Z",
    fill: "url(#paint3_linear_325_195743)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7878 89.2063C62.763 89.225 62.7434 89.2402 62.7289 89.2516C62.6178 89.7758 62.7751 90.3593 63.1821 90.9947C63.5992 91.646 64.2703 92.3383 65.1475 93.0539C66.9012 94.4847 69.4563 95.9907 72.3773 97.4329C78.2183 100.317 85.4978 102.934 90.6921 104.176C95.8864 105.419 103.562 106.379 110.076 106.45C113.333 106.486 116.293 106.299 118.505 105.817C119.611 105.576 120.523 105.262 121.189 104.87C121.84 104.488 122.244 104.038 122.382 103.521C122.374 103.504 122.364 103.482 122.35 103.454C122.316 103.384 122.262 103.28 122.184 103.145C122.03 102.874 121.781 102.48 121.408 101.988C120.662 101.003 119.416 99.6266 117.423 98.0701C113.437 94.9572 106.458 91.122 94.4989 88.2615C82.5403 85.4009 74.5813 85.6629 69.6177 86.635C67.1359 87.121 65.4022 87.7847 64.2912 88.325C63.7356 88.5952 63.3355 88.8346 63.0753 89.0057C62.9452 89.0912 62.85 89.1596 62.7878 89.2063Z",
    fill: "url(#paint4_linear_325_195743)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2676 97.1859C81.3439 94.573 71.0791 89.1419 71.744 86.3626C71.744 86.3626 80.4417 84.9484 94.3964 88.2864C108.351 91.6243 115.055 96.4645 115.055 96.4645C114.39 99.2437 103.191 99.7989 92.2676 97.1859Z",
    fill: "#667FE1",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7816 103.979C80.5111 101.522 61.9916 93.7282 63.0541 89.2864C63.0541 89.2864 62.2528 95.1724 91.2301 102.104C120.207 109.035 122.156 103.424 122.156 103.424C121.094 107.865 101.052 106.435 90.7816 103.979Z",
    fill: "url(#paint5_linear_325_195743)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8529 104.885C82.5282 105.457 85.1914 105.454 85.5209 104.489C85.5209 104.489 84.8952 103.662 81.6493 102.553C78.4034 101.445 77.4021 101.716 77.4021 101.716C77.0837 102.649 79.1776 104.313 80.8529 104.885Z",
    fill: "url(#paint6_linear_325_195743)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2616 117.913C67.9106 115.059 65.2996 111.325 64.9888 111.472C64.678 111.619 65.8279 115.63 67.4338 118.897C69.0398 122.163 71.2606 125.327 71.4859 125.22C71.7112 125.114 70.6127 120.766 69.2616 117.913Z",
    fill: "url(#paint7_linear_325_195743)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.476 46.017C154.976 41.3414 162.776 37.4446 170.622 40.9211C179.469 44.8409 175.063 57.254 171.371 63.8359C172.913 65.8204 173.38 66.9192 173.38 66.9192C159.936 97.2595 124.021 103.355 97.4537 91.5832C70.8867 79.8115 51.2748 49.1119 64.7185 18.7716C64.7185 18.7716 65.8421 18.3808 68.3384 18.1897C70.7602 11.0251 76.9774 -0.440301 85.779 3.45968C93.5793 6.91594 95.951 15.2347 96.2057 22.4214C103.726 24.6256 112.78 27.8872 123.561 32.6642C134.315 37.4296 142.798 41.935 149.476 46.017Z",
    fill: "url(#paint8_linear_325_195743)",
    fillOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5832 19.3707L91.8447 31.4502C92.7098 28.5685 93.5016 22.6882 92.5561 16.8224C91.5962 10.867 88.8514 4.95432 82.6065 2.18724C80.1395 1.09409 77.8843 1.22479 75.8598 2.13165C73.8304 3.04067 72.0265 4.73275 70.4782 6.77166C67.413 10.8082 65.375 16.1708 64.5832 19.3707Z",
    fill: "url(#paint9_linear_325_195743)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8786 18.9338C68.4915 14.1643 74.6296 11.2375 83.0548 14.9707C87.1902 16.8031 90.4703 19.1739 93.0558 21.8196L89.5004 29.8436L64.8786 18.9338Z",
    fill: "url(#paint10_linear_325_195743)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M166.828 64.543L139.566 52.4635C141.12 49.8869 144.944 45.3502 149.924 42.11C154.981 38.8204 161.204 36.8817 167.449 39.6487C169.916 40.7419 171.334 42.5002 172.023 44.6091C172.713 46.723 172.671 49.196 172.201 51.7126C171.27 56.6948 168.666 61.8069 166.828 64.543Z",
    fill: "url(#paint11_linear_325_195743)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.081 64.0872C168.187 58.2069 166.232 51.6939 157.807 47.9607C153.671 46.1283 149.711 45.2912 146.015 45.1534L142.459 53.1774L167.081 64.0872Z",
    fill: "url(#paint12_linear_325_195743)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8112 17.4496C61.7555 17.4651 61.7132 17.4778 61.6841 17.4869C48.3198 47.7297 67.8663 78.3404 94.3793 90.0882C120.892 101.836 156.698 95.7518 170.123 65.5359C170.11 65.5082 170.091 65.4683 170.065 65.4167C170.009 65.3043 169.921 65.1359 169.792 64.914C169.535 64.4704 169.119 63.813 168.484 62.9629C167.213 61.2627 165.064 58.7916 161.557 55.7179C154.544 49.5703 142.1 41.0126 120.388 31.3917C98.6746 21.7707 83.9762 18.3018 74.711 17.2366C70.0785 16.7039 66.8046 16.7722 64.6913 16.9728C63.6346 17.073 62.8681 17.2064 62.367 17.3142C62.1164 17.3682 61.9322 17.4157 61.8112 17.4496Z",
    fill: "url(#paint13_linear_325_195743)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.594 17.3876C61.594 17.3876 63.6595 17.0702 65.2893 16.8706C59.402 28.3961 53.6399 50.9895 74.3017 76.3633C59.3979 61.3429 51.8971 39.2718 61.594 17.3876Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2043 20.3307C90.0982 20.3131 90.0189 20.3016 89.9644 20.2942C89.8839 20.5589 89.9305 20.9209 90.1301 21.3831C90.3498 21.8918 90.7452 22.4992 91.3098 23.1876C92.4381 24.5637 94.2268 26.2452 96.5821 28.0847C101.292 31.7627 108.252 36.061 116.688 39.7988C125.123 43.5364 132.991 45.7786 138.883 46.7825C141.829 47.2846 144.276 47.4762 146.051 47.392C146.939 47.3498 147.652 47.2388 148.173 47.0664C148.645 46.9103 148.939 46.7109 149.076 46.4867C149.034 46.4514 148.973 46.4006 148.889 46.3341C148.706 46.1888 148.417 45.9687 147.996 45.6714C147.154 45.0766 145.782 44.1728 143.668 42.9401C139.441 40.4747 132.248 36.6947 120.391 31.4408C108.534 26.1869 100.899 23.3967 96.2305 21.9203C93.8962 21.1821 92.3039 20.7725 91.2963 20.5475C90.7926 20.435 90.4351 20.3688 90.2043 20.3307Z",
    fill: "url(#paint14_linear_325_195743)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M150.979 48.0526C166.542 58.5051 169.466 65.4534 169.466 65.4534C159.17 88.6899 135.646 97.5818 113.447 95.024C125.015 88.7443 148.716 70.5583 150.979 48.0526Z",
    fill: "url(#paint15_linear_325_195743)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4337 85.4511C76.7997 76.7513 63.2674 59.0194 67.2193 40.4273C68.154 36.0299 71.8432 32.9534 76.3377 33.0561C83.1449 33.2116 95.3812 35.1951 114.875 43.8326C134.368 52.4701 144.058 60.2018 148.746 65.1398C151.841 68.4002 152.042 73.2014 149.401 76.8398C138.321 92.1063 116.048 94.1423 96.4337 85.4511Z",
    fill: "url(#paint16_linear_325_195743)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9884 35.6498C85.541 35.9625 97.0216 38.0528 115.072 46.0507C130.142 52.7284 139.086 58.7804 144.324 63.2993C139.137 60.1022 126.71 54.6587 119.77 61.6239C103.17 78.2855 88.5597 75.4973 83.0324 73.0482C79.7272 71.5837 77.5621 68.6756 77.3544 68.3886C71.9732 60.7889 68.7001 51.8164 69.9075 43.088C70.5365 38.5403 74.4026 35.431 78.9884 35.6498Z",
    fill: "url(#paint17_linear_325_195743)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M112.943 48.1945C115.504 49.3294 119.454 50.2555 119.815 49.4421C119.815 49.4421 118.776 48.4276 113.814 46.2287C108.851 44.0299 107.402 43.9422 107.402 43.9422C107.054 44.728 110.381 47.0596 112.943 48.1945Z",
    fill: "url(#paint18_linear_325_195743)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1905 29.8465C66.9387 26.7794 66.5685 22.0645 65.9204 21.9064C65.2723 21.7483 63.7241 25.3425 62.9623 28.903C62.2005 32.4634 62.1653 36.7515 62.6351 36.8661C63.1049 36.9807 65.4422 32.9136 66.1905 29.8465Z",
    fill: "url(#paint19_linear_325_195743)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M156.17 75.5606C154.047 77.8977 152.12 82.2168 152.614 82.6652C153.108 83.1137 156.185 80.6956 158.555 77.9315C160.925 75.1674 163.004 71.417 162.646 71.092C162.288 70.7669 158.292 73.2235 156.17 75.5606Z",
    fill: "url(#paint20_linear_325_195743)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M146.128 75.1081C145.162 76.1472 144.544 78.331 144.886 78.6493C145.229 78.9676 146.745 78.0087 147.805 76.7612C148.866 75.5137 149.64 73.6711 149.392 73.4404C149.144 73.2096 147.094 74.0689 146.128 75.1081Z",
    fill: "url(#paint21_linear_325_195743)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M119.732 32.9251C110.657 28.9041 104.037 25.2861 104.195 24.9288C104.195 24.9288 107.597 25.897 120.343 31.545C133.09 37.1929 136.086 39.0593 136.086 39.0593C135.934 39.4022 128.806 36.9462 119.732 32.9251Z",
    fill: "url(#paint22_linear_325_195743)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M110.193 61.5571C109.965 61.8625 109.747 62.1793 109.54 62.5073L110.311 62.9941C110.216 63.146 110.122 63.3005 110.032 63.4576C109.941 63.6147 109.854 63.7727 109.77 63.9316L108.963 63.5065C108.782 63.8496 108.617 64.1968 108.466 64.547L109.304 64.9071C109.161 65.2405 109.033 65.5767 108.918 65.915L108.054 65.6231C107.93 65.9897 107.822 66.3587 107.73 66.729L108.615 66.9501C108.527 67.3013 108.454 67.6536 108.396 68.0062L107.496 67.858C107.433 68.2393 107.387 68.621 107.356 69.0021L108.265 69.0757C108.236 69.4354 108.222 69.7944 108.223 70.1516L107.31 70.1536C107.311 70.5395 107.328 70.9237 107.361 71.305L108.27 71.2265C108.301 71.5851 108.347 71.941 108.408 72.2929L107.509 72.4483C107.575 72.8281 107.656 73.204 107.754 73.5746L108.636 73.3423C108.728 73.6891 108.834 74.0309 108.955 74.3665L108.096 74.6753C108.226 75.0374 108.372 75.3932 108.534 75.7413L109.362 75.3571C109.512 75.6809 109.677 75.9974 109.855 76.3056L109.066 76.7636C109.259 77.0958 109.467 77.4191 109.69 77.7326L110.434 77.2033C110.64 77.4925 110.859 77.7724 111.092 78.0419L110.402 78.6388C110.653 78.9283 110.918 79.2069 111.197 79.4734L111.827 78.8135C112.082 79.0573 112.351 79.2902 112.632 79.5112L112.068 80.2284C112.367 80.4642 112.681 80.6874 113.007 80.8969L113.5 80.1292C113.649 80.2249 113.801 80.3175 113.956 80.407C114.111 80.4965 114.267 80.5818 114.424 80.663L114.006 81.4738C114.35 81.6516 114.7 81.8112 115.054 81.9531L115.393 81.1061C115.725 81.2391 116.061 81.3551 116.4 81.4544L116.143 82.33C116.513 82.4386 116.887 82.5288 117.263 82.6011L117.435 81.705C117.785 81.7723 118.137 81.8227 118.491 81.8565L118.404 82.7648C118.787 82.8015 119.171 82.8201 119.555 82.8211L119.557 81.9087C119.914 81.9096 120.27 81.8941 120.626 81.8625L120.706 82.7713C121.089 82.7373 121.47 82.6861 121.849 82.6179L121.687 81.7199C122.038 81.6567 122.387 81.5779 122.733 81.4837L122.973 82.364C123.343 82.2633 123.709 82.1463 124.071 82.0133L123.756 81.1569C124.091 81.0337 124.423 80.8958 124.749 80.7434L125.135 81.57C125.482 81.4079 125.823 81.2307 126.158 81.0386L125.704 80.2473C126.013 80.0694 126.317 79.8779 126.614 79.6729L127.133 80.4238C127.447 80.2066 127.754 79.9754 128.053 79.7305L127.475 79.0248C127.751 78.7983 128.02 78.5591 128.281 78.3077L128.914 78.9639C129.189 78.6987 129.455 78.4208 129.71 78.1303L129.025 77.5274C129.261 77.2594 129.488 76.98 129.706 76.6894L130.436 77.2356C130.665 76.9303 130.883 76.6135 131.09 76.2855L130.318 75.7986C130.414 75.6467 130.507 75.4922 130.598 75.3352C130.688 75.1781 130.776 75.02 130.859 74.8611L131.667 75.2863C131.847 74.9431 132.013 74.596 132.163 74.2457L131.325 73.8856C131.468 73.5523 131.597 73.216 131.711 72.8777L132.575 73.1697C132.699 72.803 132.807 72.4341 132.9 72.0637L132.014 71.8426C132.102 71.4915 132.175 71.1391 132.233 70.7865L133.133 70.9347C133.196 70.5534 133.243 70.1717 133.274 69.7907L132.364 69.717C132.393 69.3573 132.407 68.9984 132.406 68.6411L133.319 68.6391C133.318 68.2532 133.301 67.8691 133.268 67.4877L132.359 67.5662C132.328 67.2076 132.282 66.8518 132.221 66.4999L133.12 66.3444C133.055 65.9646 132.973 65.5888 132.875 65.2181L131.993 65.4505C131.902 65.1036 131.795 64.7618 131.675 64.4262L132.533 64.1175C132.403 63.7553 132.257 63.3995 132.095 63.0514L131.268 63.4356C131.117 63.1118 130.953 62.7953 130.774 62.4872L131.563 62.0292C131.37 61.697 131.162 61.3736 130.939 61.0602L130.196 61.5894C129.99 61.3002 129.77 61.0203 129.537 60.7509L130.227 60.1539C129.977 59.8644 129.712 59.5858 129.432 59.3193L128.802 59.9793C128.547 59.7354 128.279 59.5025 127.998 59.2815L128.562 58.5643C128.262 58.3285 127.949 58.1054 127.623 57.8958L127.129 58.6635C126.98 58.5678 126.829 58.4752 126.674 58.3857C126.519 58.2963 126.363 58.211 126.205 58.1298L126.624 57.319C126.279 57.1412 125.929 56.9815 125.575 56.8396L125.236 57.6866C124.904 57.5537 124.568 57.4377 124.23 57.3383L124.486 56.4628C124.116 56.3541 123.742 56.2639 123.366 56.1917L123.194 57.0877C122.844 57.0204 122.492 56.9701 122.139 56.9362L122.226 56.0279C121.843 55.9913 121.458 55.9726 121.074 55.9716L121.072 56.8841C120.716 56.8831 120.359 56.8986 120.004 56.9302L119.923 56.0214C119.541 56.0554 119.159 56.1066 118.781 56.1748L118.942 57.0728C118.591 57.136 118.242 57.2148 117.896 57.3091L117.656 56.4287C117.287 56.5294 116.92 56.6464 116.558 56.7794L116.873 57.6358C116.538 57.759 116.207 57.8969 115.881 58.0493L115.494 57.2227C115.147 57.3848 114.806 57.562 114.472 57.7541L114.926 58.5455C114.616 58.7233 114.312 58.9149 114.015 59.1198L113.497 58.3689C113.182 58.5861 112.875 58.8173 112.576 59.0622L113.154 59.768C112.878 59.9945 112.609 60.2336 112.349 60.485L111.715 59.8288C111.44 60.094 111.175 60.372 110.919 60.6624L111.604 61.2653C111.368 61.5333 111.141 61.8127 110.924 62.1034L110.193 61.5571Z",
    stroke: "#8FDBFF",
    strokeWidth: 1.82484,
    strokeDasharray: "1.22 1.22"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1884 45.3588C79.9763 45.7038 79.7779 46.0623 79.5947 46.4337L80.4129 46.8374C80.329 47.0075 80.2485 47.1805 80.1715 47.3564C80.0944 47.5323 80.022 47.7088 79.9539 47.8858L79.1022 47.5585C78.9537 47.9451 78.8248 48.334 78.7153 48.7239L79.5937 48.9707C79.4896 49.3413 79.4042 49.7125 79.3372 50.0829L78.4393 49.9204C78.3657 50.3272 78.3125 50.7335 78.2792 51.1377L79.1885 51.2126C79.1571 51.5944 79.1448 51.9738 79.1511 52.3492L78.2388 52.3646C78.2458 52.7774 78.2736 53.1862 78.3216 53.5892L79.2277 53.4812C79.2728 53.8596 79.3371 54.2319 79.4201 54.5965L78.5305 54.799C78.622 55.2012 78.7345 55.5954 78.8674 55.9795L79.7297 55.6813C79.8533 56.0384 79.9957 56.3853 80.1564 56.7204L79.3336 57.1148C79.5115 57.4859 79.7102 57.8444 79.9289 58.1883L80.6988 57.6985C80.8992 58.0135 81.1177 58.3143 81.3534 58.599L80.6507 59.181C80.9119 59.4963 81.1929 59.7946 81.493 60.0735L82.1142 59.4052C82.3836 59.6555 82.6696 59.8883 82.9719 60.1018L82.4455 60.8471C82.7772 61.0814 83.1268 61.295 83.4935 61.4858L83.9146 60.6764C84.0772 60.7609 84.2435 60.8406 84.4136 60.915C84.5837 60.9895 84.7551 61.0577 84.9274 61.1197L84.6184 61.9782C85.0074 62.1183 85.4014 62.2302 85.7986 62.315L85.9891 61.4227C86.351 61.4999 86.7161 61.5522 87.0828 61.5803L87.0131 62.4901C87.4216 62.5213 87.8314 62.5255 88.2403 62.5035L88.1912 61.5924C88.5603 61.5725 88.9295 61.529 89.2968 61.4626L89.4592 62.3604C89.8602 62.2879 90.2584 62.1907 90.6518 62.0697L90.3835 61.1976C90.7386 61.0883 91.0902 60.9576 91.4364 60.8062L91.8022 61.6421C92.1746 61.4791 92.5405 61.2944 92.8981 61.0888L92.4434 60.2978C92.7676 60.1114 93.0848 59.9062 93.3934 59.6826L93.9287 60.4216C94.2574 60.1835 94.5766 59.9266 94.8846 59.6518L94.277 58.971C94.5572 58.721 94.8276 58.4546 95.0868 58.1725L95.7587 58.7898C96.0331 58.4912 96.2955 58.1764 96.5445 57.8464L95.816 57.297C96.0427 56.9964 96.2576 56.6819 96.4592 56.3541L97.2364 56.832C97.4485 56.487 97.6469 56.1285 97.8301 55.7572L97.0119 55.3534C97.0958 55.1834 97.1764 55.0104 97.2534 54.8345C97.3304 54.6585 97.4029 54.482 97.4709 54.305L98.3226 54.6323C98.4711 54.2458 98.6 53.8569 98.7095 53.4669L97.8311 53.2201C97.9353 52.8496 98.0206 52.4784 98.0876 52.1079L98.9855 52.2704C99.0591 51.8637 99.1123 51.4574 99.1456 51.0531L98.2363 50.9782C98.2677 50.5965 98.28 50.2171 98.2737 49.8416L99.186 49.8262C99.179 49.4135 99.1512 49.0047 99.1032 48.6017L98.1972 48.7097C98.1521 48.3313 98.0877 47.959 98.0047 47.5944L98.8944 47.3919C98.8028 46.9897 98.6903 46.5955 98.5574 46.2113L97.6951 46.5096C97.5716 46.1525 97.4291 45.8055 97.2685 45.4705L98.0912 45.076C97.9133 44.7049 97.7146 44.3464 97.4959 44.0026L96.726 44.4923C96.5256 44.1773 96.3072 43.8766 96.0714 43.5919L96.7741 43.0099C96.5129 42.6945 96.2319 42.3963 95.9318 42.1173L95.3106 42.7857C95.0413 42.5353 94.7552 42.3025 94.4529 42.0891L94.9793 41.3438C94.6476 41.1095 94.298 40.8959 93.9313 40.7051L93.5102 41.5145C93.3477 41.4299 93.1813 41.3503 93.0112 41.2758C92.8411 41.2013 92.6697 41.1331 92.4974 41.0711L92.8064 40.2126C92.4175 40.0726 92.0234 39.9607 91.6262 39.8759L91.4357 40.7682C91.0738 40.6909 90.7087 40.6386 90.3421 40.6105L90.4117 39.7008C90.0032 39.6695 89.5935 39.6654 89.1846 39.6874L89.2336 40.5985C88.8645 40.6183 88.4954 40.6618 88.128 40.7283L87.9656 39.8304C87.5646 39.903 87.1664 40.0002 86.773 40.1212L87.0413 40.9933C86.6862 41.1025 86.3346 41.2332 85.9884 41.3847L85.6227 40.5488C85.2502 40.7118 84.8843 40.8965 84.5267 41.102L84.9814 41.8931C84.6572 42.0794 84.34 42.2847 84.0314 42.5082L83.4961 41.7693C83.1674 42.0074 82.8482 42.2642 82.5402 42.5391L83.1478 43.2198C82.8676 43.4699 82.5972 43.7363 82.338 44.0183L81.6661 43.401C81.3917 43.6997 81.1293 44.0144 80.8804 44.3444L81.6088 44.8939C81.3821 45.1945 81.1673 45.5089 80.9657 45.8368L80.1884 45.3588Z",
    stroke: "#8FDBFF",
    strokeWidth: 1.82484,
    strokeDasharray: "1.22 1.22"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5808 90.5353C62.5808 90.5353 63.2987 93.0595 64.2516 94.4808C61.6547 102.997 64.3932 124.883 81.1548 133.407C66.2208 126.944 58.5618 109.382 62.5808 90.5353Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M115.668 110.898C114.409 113.988 115.82 116.63 116.747 116.586C117.674 116.542 118.095 116.084 119.56 112.487C121.026 108.89 121.207 108.411 120.413 107.589C119.618 106.767 116.927 107.809 115.668 110.898Z",
    fill: "url(#paint23_linear_325_195743)",
    fillOpacity: 0.4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M113.905 113.284C110.68 119.241 110.03 124.556 111.055 124.042C112.081 123.528 116.828 117.56 118.778 113.764C120.729 109.967 121.189 108.56 120.433 107.617C119.678 106.674 117.129 107.326 113.905 113.284Z",
    fill: "url(#paint24_linear_325_195743)",
    fillOpacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6127 130.878C98.2858 128.781 117.191 119.243 116.647 115.174C116.102 111.104 96.0146 110.962 80.6229 113.47C65.2311 115.978 48.9363 117.913 49.6852 123.504C50.4341 129.096 66.9396 132.975 82.6127 130.878Z",
    fill: "url(#paint25_linear_325_195743)",
    fillOpacity: 0.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M83.767 127.415C99.4401 125.318 118.345 115.78 117.801 111.711C117.257 107.642 97.1689 107.5 81.7772 110.007C66.3854 112.515 50.0906 114.45 50.8395 120.041C51.5883 125.633 68.0939 129.512 83.767 127.415Z",
    fill: "url(#paint26_linear_325_195743)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8466 109.697C66.4946 112.142 50.2539 114.1 50.9063 118.971C50.9063 118.971 51.3717 115.122 81.3162 111.034C115.895 106.314 117.289 110.946 117.289 110.946C116.815 107.401 97.1985 107.252 81.8466 109.697Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7692 127.416C68.0961 129.513 51.5906 125.633 50.8417 120.042C50.7284 119.196 51.0052 118.434 51.6099 117.74C51.6099 117.74 58.5122 120.706 73.3781 122.51C93.5571 124.959 101.063 122.759 102.573 122.196C102.673 122.155 102.774 122.114 102.873 122.073C102.873 122.073 102.779 122.119 102.573 122.196C96.7448 124.571 90.0015 126.582 83.7692 127.416Z",
    fill: "url(#paint27_linear_325_195743)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5508 115.007C83.1942 114.575 88.2264 112.672 88.1574 112.091C88.0884 111.509 83.5677 111.469 79.3781 112.058C75.1885 112.647 70.4728 114.075 70.5228 114.496C70.5729 114.918 75.9073 115.44 79.5508 115.007Z",
    fill: "url(#paint28_linear_325_195743)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5914 99.0026C65.3161 102.328 62.8623 104.045 62.0557 103.587C61.2491 103.128 61.0811 102.529 61.4019 98.6581C61.7227 94.7872 61.778 94.2778 62.8581 93.9045C63.9382 93.5312 65.8667 95.6775 65.5914 99.0026Z",
    fill: "url(#paint29_linear_325_195743)",
    fillOpacity: 0.4
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0853 101.928C66.2649 108.7 64.4404 113.733 63.7585 112.811C63.0766 111.888 61.5437 104.419 61.5224 100.15C61.5011 95.8821 61.7274 94.4197 62.8277 93.9203C63.9279 93.4208 65.9058 95.1557 66.0853 101.928Z",
    fill: "url(#paint30_linear_325_195743)",
    fillOpacity: 0.3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1642 77.4392C39.4009 90.2738 56.7235 102.452 60.0559 100.054C63.3884 97.6555 54.0457 79.8722 44.5793 67.4794C35.1128 55.0866 25.7265 41.627 21.148 44.9229C16.5695 48.2189 20.9276 64.6045 30.1642 77.4392Z",
    fill: "url(#paint31_linear_325_195743)",
    fillOpacity: 0.3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7639 76.8264C43.0005 89.661 60.3231 101.839 63.6555 99.4408C66.988 97.0427 57.6453 79.2594 48.1789 66.8666C38.7125 54.4738 29.3261 41.0142 24.7476 44.3101C20.1691 47.6061 24.5272 63.9917 33.7639 76.8264Z",
    fill: "url(#paint32_linear_325_195743)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M48.485 66.7802C39.093 54.3927 29.7106 40.9924 25.7222 43.8636C25.7222 43.8636 29.3369 42.4596 47.0557 66.9427C67.5165 95.2147 64.0886 98.6272 64.0886 98.6272C66.9915 96.5383 57.877 79.1677 48.485 66.7802Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7652 76.8264C24.5285 63.9918 20.1704 47.6061 24.7489 44.3102C25.4416 43.8116 26.2442 43.6964 27.1406 43.903C27.1406 43.903 27.7786 51.3882 33.1943 65.3497C40.5454 84.3009 46.023 89.8837 47.2313 90.9504C47.3147 91.0197 47.3981 91.0887 47.4814 91.1573C47.4814 91.1573 47.396 91.0958 47.2313 90.9504C42.3894 86.9297 37.438 81.93 33.7652 76.8264Z",
    fill: "url(#paint33_linear_325_195743)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7194 67.2565C44.818 70.2661 48.868 73.8074 49.3483 73.4725C49.8285 73.1377 47.733 69.1317 45.2389 65.7143C42.7448 62.2968 39.263 58.8107 38.9149 59.0534C38.5668 59.2962 40.6208 64.2469 42.7194 67.2565Z",
    fill: "url(#paint34_linear_325_195743)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 37.3677,
    ry: 13.4652,
    transform: "matrix(-1 -6.25916e-10 -6.25916e-10 1 83.8999 155.49)",
    fill: "url(#paint35_radial_325_195743)",
    fillOpacity: 0.4
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M131.279 6.80981L120.559 31.0044",
    stroke: "url(#paint36_linear_325_195743)",
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.56926,
    ry: 5.39037,
    transform: "matrix(-0.914268 -0.40511 -0.40511 0.914268 131.404 6.86545)",
    fill: "url(#paint37_linear_325_195743)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_325_195743",
    x1: 62.815,
    y1: 102.317,
    x2: 127.1,
    y2: 117.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_325_195743",
    x1: 121.399,
    y1: 108.19,
    x2: 61.4947,
    y2: 93.8605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_325_195743",
    x1: 119.542,
    y1: 115.95,
    x2: 94.3902,
    y2: 118.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693995,
    stopColor: "#C3DFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_325_195743",
    x1: 59.6379,
    y1: 101.621,
    x2: 80.895,
    y2: 115.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693995,
    stopColor: "#C3DFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_325_195743",
    x1: 121.391,
    y1: 108.188,
    x2: 61.5005,
    y2: 93.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#E9E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#E9E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_325_195743",
    x1: 92.1143,
    y1: 101.616,
    x2: 91.5329,
    y2: 104.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336756,
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_325_195743",
    x1: 81.6493,
    y1: 102.553,
    x2: 80.8529,
    y2: 104.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771045,
    stopColor: "#CCD7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_325_195743",
    x1: 67.9543,
    y1: 118.532,
    x2: 69.2107,
    y2: 118.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_325_195743",
    x1: 60.2056,
    y1: 28.9568,
    x2: 176.813,
    y2: 80.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_325_195743",
    x1: 78.0838,
    y1: 32.7945,
    x2: 80.9059,
    y2: 1.30063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821767,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_325_195743",
    x1: 62.2233,
    y1: 17.7572,
    x2: 93.2585,
    y2: 21.3621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369241,
    stopColor: "#C2DEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687753,
    stopColor: "#B4CDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABBFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_325_195743",
    x1: 147.815,
    y1: 63.5601,
    x2: 169.248,
    y2: 40.3129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821767,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_325_195743",
    x1: 169.736,
    y1: 65.2638,
    x2: 146.217,
    y2: 44.6959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369241,
    stopColor: "#C2DEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687753,
    stopColor: "#B4CDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABBFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_325_195743",
    x1: 167.684,
    y1: 71.3417,
    x2: 59.0222,
    y2: 23.1942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_325_195743",
    x1: 148.808,
    y1: 47.4032,
    x2: 89.4774,
    y2: 21.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#BCBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#BBBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#97B1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91C5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_325_195743",
    x1: 152.243,
    y1: 86.5327,
    x2: 139.821,
    y2: 71.3458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3DFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_325_195743",
    x1: 143.366,
    y1: 83.0964,
    x2: 69.1597,
    y2: 34.2921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1DA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470359,
    stopColor: "#3134D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_325_195743",
    x1: 114.735,
    y1: 66.4986,
    x2: 72.5168,
    y2: 35.4846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602DDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3134D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_325_195743",
    x1: 113.814,
    y1: 46.2287,
    x2: 112.943,
    y2: 48.1945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771045,
    stopColor: "#C7C5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_325_195743",
    x1: 63.464,
    y1: 29.1812,
    x2: 65.9119,
    y2: 30.0938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_325_195743",
    x1: 158.974,
    y1: 77.7866,
    x2: 156.293,
    y2: 75.2621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.387196,
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_325_195743",
    x1: 147.568,
    y1: 76.4473,
    x2: 146.486,
    y2: 74.9929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_325_195743",
    x1: 119.086,
    y1: 32.6393,
    x2: 119.761,
    y2: 31.1165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458744,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_325_195743",
    x1: 119.563,
    y1: 112.48,
    x2: 115.67,
    y2: 110.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_325_195743",
    x1: 119.088,
    y1: 113.752,
    x2: 115.159,
    y2: 112.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_325_195743",
    x1: 116.819,
    y1: 116.464,
    x2: 45.0497,
    y2: 126.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_325_195743",
    x1: 117.001,
    y1: 111.361,
    x2: 51.1408,
    y2: 117.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295244,
    stopColor: "#E4E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593241,
    stopColor: "#DBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_325_195743",
    x1: 72.5428,
    y1: 121.457,
    x2: 71.2553,
    y2: 127.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7B5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_325_195743",
    x1: 79.2607,
    y1: 112.561,
    x2: 79.3277,
    y2: 114.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_325_195743",
    x1: 61.4026,
    y1: 98.6501,
    x2: 65.5919,
    y2: 98.9973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_325_195743",
    x1: 61.2515,
    y1: 99.9995,
    x2: 65.4797,
    y2: 100.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_325_195743",
    x1: 58.9992,
    y1: 100.814,
    x2: 16.7033,
    y2: 42.0423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_325_195743",
    x1: 63.5872,
    y1: 98.5709,
    x2: 26.702,
    y2: 43.6074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295244,
    stopColor: "#E4E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593241,
    stopColor: "#DBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_325_195743",
    x1: 33.7291,
    y1: 64.1167,
    x2: 27.827,
    y2: 65.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7B5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_325_195743",
    x1: 44.7399,
    y1: 65.8478,
    x2: 42.7442,
    y2: 66.9903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_325_195743",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3677 13.4652) rotate(90) scale(11.9462 33.1524)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AE7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#9AE7FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_325_195743",
    x1: 130.822,
    y1: 6.60726,
    x2: 120.102,
    y2: 30.8018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#C1E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_325_195743",
    x1: 5.56926,
    y1: 0,
    x2: 5.56926,
    y2: 10.7807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421216,
    stopColor: "#C2E0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2C9FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotPic);
export default __webpack_public_path__ + "static/media/bot-pic.c9be3366c0abbb6fc1a76d872ca284be.svg";
export { ForwardRef as ReactComponent };